import PropTypes from "prop-types";
import * as React from "react";
import React__default, { forwardRef } from "react";
import { Box } from "../Box/Box.js";
const SvgCircleCheck = (props) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 11.5, cy: 11.5, r: 11.5, fill: "#6EA76D" }), /* @__PURE__ */ React.createElement("path", { d: "M7 12.2778L9.8 15L17 8", stroke: "white" }));
const Alert = forwardRef(
  ({ message = null, severity = "success", handleClose, style = null }, ref) => {
    const getSeverityStyles = () => {
      switch (severity) {
        case "error":
          return {
            border: "1px solid #F34C41",
            backgroundColor: "#F6DBD5"
          };
        case "success":
        default:
          return {
            border: "1px solid #6EA76D",
            backgroundColor: "#F9FBF9"
          };
      }
    };
    const getSeverityIcon = () => {
      switch (severity) {
        case "error":
          return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null);
        case "success":
        default:
          return /* @__PURE__ */ React__default.createElement(SvgCircleCheck, null);
      }
    };
    const styles = {
      container: {
        width: "100%",
        maxWidth: "1100px",
        ...style == null ? void 0 : style.container
      },
      alert: {
        backgroundColor: "#F9FBF9",
        padding: "16px",
        border: "1px solid #6EA76D",
        display: "flex",
        borderRadius: "8px",
        width: "100%",
        alignItems: "center",
        boxShadow: "0px 4px 21px rgba(195, 195, 195, 0.25)",
        gap: "12px",
        justifyContent: "space-between",
        ...getSeverityStyles(),
        ...style == null ? void 0 : style.alert
      },
      dismissButton: {
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        ...style == null ? void 0 : style.dismissButton
      }
    };
    return /* @__PURE__ */ React__default.createElement(Box, { style: styles.container }, /* @__PURE__ */ React__default.createElement(Box, { style: styles.alert }, /* @__PURE__ */ React__default.createElement(Box, { style: { width: "100%", alignItems: "center", display: "flex", gap: "12px" } }, getSeverityIcon(), /* @__PURE__ */ React__default.createElement(Box, null, message)), /* @__PURE__ */ React__default.createElement(Box, { style: styles.dismissButton, onClick: handleClose }, "Dismiss")));
  }
);
Alert.propTypes = {
  style: PropTypes.shape({}),
  message: PropTypes.string,
  severity: PropTypes.string
};
export {
  Alert
};
//# sourceMappingURL=Alert.js.map
